<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>기업연혁</h3>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="box justify-content-center">
                                <!-- banner -->
                                <div class="col-lg-12 yaer-header-div"
                                    style="background-image: url('img/theme/main8.png');">
                                </div>
                                <!-- //banner -->
                                <!-- 2024 -->
                                <div class="col-lg-12">
                                    <div class="row" style="display: flex;">
                                        <div class="col-lg-2 year yaer-div line">
                                            2024
                                        </div>
                                        <div class="col-lg-10 yaer-div line">
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>03</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>(주)포스트개발 상도 푸르지오 클라베뉴아파트 포장공사 외 3개소</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>에스와이써비스 점토블럭 하자보수공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>02</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울대학교 서울대공대간이식당 오수관로 보수공사</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- //2024 -->
                                <!-- 2023 -->
                                <div class="col-lg-12">
                                    <div class="row" style="display: flex;">
                                        <div class="col-lg-2 year yaer-div line">
                                            2023
                                        </div>
                                        <div class="col-lg-10 yaer-div line">
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>12</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>경륜경정총관본부 경정장 경수수면 결빙방지장치 설치공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>11</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 동작구청 도로교통 소통 개선공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 강서구청 개화사거리 도로교통 소통 개선공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 노원구청 마들공원 우수연결공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>09</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>법무부 서울보호관찰소 도로 포장공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>08</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>한국농수산식품유통공사 옥외주차장 우수배관 신설공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>06</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>경륜경정총괄본부 경정장 경주시설 긴급 보수공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>(주)프라임씨앤씨 용산동 주상복합 신축공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>05</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울대학교 오수맨홀 파손부위 보수공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>04</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>신부종합건설(주) 이촌로 가정하수관 포장공사 및 시설공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>중산고등학교 교사동 후면 주차장 설치공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>03</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 금천구청 문화거점 건립예정부지 임시공영 주차장 조성공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 용산구청 독서당로 하수관로 정비공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>강남수도사업소 수서동외 14개동 상수도공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 광진구 면목로 하수관로 개량공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>02</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>경륜경정총괄본부 경정장 경주수면 소파시설 긴급 보수공사</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- //2023 -->
                                <!-- 2022 -->
                                <div class="col-lg-12">
                                    <div class="row" style="display: flex;">
                                        <div class="col-lg-2 year yaer-div line">
                                            2022
                                        </div>
                                        <div class="col-lg-10 yaer-div line">
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>12</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>법무부 서울보호관찰소 청사 보도블럭 교체공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>(주)대운전력개발 관로공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>11</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>동작르네상스사업단 남성사계시장 겨울길 점검구 교체공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>10</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>동작르네상스사업단 남성사계시장 겨울길 포장 및 빗물받이 교체공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>07</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 동작구 꿈나무어린이집 통학로 정비공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>05</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>소미건설(주) 우수관연결공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>동작르네상스사업단 빗물받이 보수공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>03</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 동작구 어린이보호구역 정비공사(연꽃어린이집)</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 서초구 방배권역 골목길 개선사업</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- //2022 -->
                                <!-- 2021 -->
                                <div class="col-lg-12">
                                    <div class="row" style="display: flex;">
                                        <div class="col-lg-2 year yaer-div line">
                                            2021
                                        </div>
                                        <div class="col-lg-10 yaer-div line">
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>10</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 서초그린파킹 주차장 공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>08</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>아이디종합건설(주) 공항동 주차장 포장공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span style="color:#FFF">00</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 관악구청 중부시장 도로환경 개선공사</span>
                                                </div>
                                            </div>
                                            <div style="display: flex;">
                                                <div class="rel-div month">
                                                    <span>07</span>
                                                </div>
                                                <div class="rel-div day">
                                                    <span>서울시 용산구 보광동 공사</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- //2021 -->
                                <div class="col-lg-12">
                                    <div class="col-lg-3" style="padding-top: 30px;">
                                        <div class="items-mid scale">
                                            <img src="img/theme/history-1.jpg" class="w-2" style="height: 200px;">
                                        </div>
                                        <p>사업자등록증</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.yaer-header-div {
    height: 280px;
    margin-bottom: 20px;
    background-position: center center;
    background-size: cover;
}

.year {
        font-weight: 400;
        font-size: 30px;
    }

.month {
    font-weight: 400;
    font-size: 20px;
    top: 8px;
}

.day {
    top: 10px;
    margin-left: 30px;
}

.rel-div {
    position: relative;
}

.yaer-div {
    padding: 40px 0 40px 0;
}

.line {
    border-bottom: 1px solid #e9ecef;
}

.w-2 {
    max-width: 200px;
    max-height: 200px;
}

.items-mid {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}

.scale img {
  transition: all 0.2s linear;
}
.scale:hover img {
  transform: scale(3);
}
</style>
